import { Directive, ElementRef, HostListener, Renderer2, Renderer } from '@angular/core';

@Directive({
  selector: '[appCheckBlurValue]'
})
export class CheckBlurValueDirective {

  constructor(private Ref:ElementRef , private renderer :Renderer2) { }

  @HostListener ('blur') onblur()
  {
}

}
